import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba624dd8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ba624dd8&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=ba624dd8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba624dd8",
  null
  
)

export default component.exports